/* eslint-disable react-hooks/exhaustive-deps */
import { ErrorMessage } from '@hookform/error-message';
import { Button as Btn } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import React, { useEffect, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { Controller, FormProvider, useForm, useFormContext } from 'react-hook-form';
import useProcessRules from 'src/hooks/useProcessRules';
import uuid from 'uuid';
import InputsDinamicos from '..';
import DangerouslyHtml from 'src/components/DangerouslyHtml';

const SubForm: React.FC<any> = (props) => {
  const { fields, campo, codCore } = props;
  const methods = useFormContext();
  const { control, formState: { errors } } = methods;
  const { processValidations } = useProcessRules(props);
  const rules = processValidations();

  return (
    <div className="form-group p-3">
      <Controller
        control={control}
        name={codCore}
        defaultValue={
          [
            //   {
            //     apel: 'ORTIZ',
            //     fnac: '17/01/1993',
            //     nom: 'XAVIER',
            //     uniqueKeyV4: 'e75d83eb-d9f2-495c-9bc8-1a8e70a90ae2',
            //   },
          ]
        }
        rules={{
          ...rules,
          validate: {
            ...rules?.validate,
            required: (value) => {
              if (!value && props?.min === 0 && value?.length === 0) {
                return 'Este campo es obligatorio';
              }
              return true;
            },
            min: (value) => {
              console.log('VALUE: ', props.min);
              if (props?.min && props?.min !== 0 && value?.length < props?.min) {
                return `La cantidad mínima de items ingresados es ${props?.min}`;
              }
              return true;
            },
            max: (value) => {
              if (props?.max && props?.max !== 0 && value?.length > props?.max) {
                return `La cantidad máxima de items ingresados es ${props?.min}`;
              }
              return true;
            },
          },
        }}
        render={({ field: { onChange, value, name } }) => (
          <React.Fragment>
            <div className="py-3">
              <DangerouslyHtml>{props?.labelPlugin}</DangerouslyHtml>
            </div>
            {value?.length < props?.max && (
              <ModalForm
                campo={campo}
                fields={fields}
                setter={onChange}
                labelPlugin={props?.labelPlugin}
                lista={value}
                parentMethods={methods}
              />
            )}

            {value?.length === props?.max && <h4>Ha completado el ingreso de "{campo}"</h4>}
            <ErrorMessage
              name={name}
              errors={errors}
              render={({ message }) => <p className="p-invalid text-danger">{message}</p>}
            />
            <DataTable
              value={value}
              className="p-datatable-gridlines p-datatable-sm"
              autoLayout
            //   header={header}
            >
              <Column
                header="#"
                headerClassName="text-center"
                //@ts-ignore
                body={(_, data) => <strong>{data?.rowIndex + 1}</strong>}
              />
              {/* <Column header="id" headerClassName="text-center" field="uniqueKeyV4" /> */}
              {fields?.map?.((field, index) => (
                <Column
                  key={index}
                  header={field?.campo}
                  headerClassName="text-center"
                  field={field?.codCore}
                />
              ))}

              <Column
                header="Opciones"
                headerClassName="text-center"
                style={{ width: '80px' }}
                body={(rowData) => (
                  <div className="d-inline-flex ">
                    <ModalForm
                      campo={campo}
                      fields={fields}
                      setter={onChange}
                      labelPlugin={props?.labelPlugin}
                      lista={value}
                      value={rowData}
                      accion="upt"
                      parentMethods={methods}
                    />
                    <Btn
                      className="p-button-sm p-button-danger"
                      icon="pi pi-trash"
                      type="button"
                      onClick={() => {
                        onChange(
                          value?.filter?.((item) => item?.uniqueKeyV4 !== rowData?.uniqueKeyV4),
                        );
                      }}
                    />
                  </div>
                )}
              />
            </DataTable>
          </React.Fragment>
        )}
      />

    </div>
  );
};

export default SubForm;

const ModalForm = ({
  campo,
  fields,
  setter,
  labelPlugin,
  accion = 'add',
  value = {},
  lista = [],
  parentMethods
}: any) => {

  console.log('MODAL:', { campo, fields, setter, value, lista, accion })

  console.log("fields", fields, campo)
  const [show, setShow] = useState(false);
  const toggle = () => {
    methods.reset(value);
    setShow(!show);
  }
  const methods = useForm({ mode: 'onChange', defaultValues: value });

  useEffect(() => {
    if (accion === 'upt') {
      methods.reset(value);
    }
  }, [value]);

  const onSubmit = (data) => {
    if (accion === 'add') {
      lista.push(data);
      setter([...lista]);
    } else {
      const newLista = lista?.filter?.((item) => item?.uniqueKeyV4 !== value?.uniqueKeyV4);
      newLista.push(data);
      setter([...newLista]);
    }
    toggle();
  };

  const onSubmitError = (errors) => {
    console.log('ERROR: ', errors);
  };

  return (
    <>
      <FormProvider {...{ ...methods, parentMethods }}>
        {accion === 'add' && (
          <label className=" btn btn-primary pointer pt-2" onClick={() => {
            methods.setValue('uniqueKeyV4', uuid.v4());
            toggle();
          }} >
            {`+ Agregar ${campo}`}
          </label>
        )}

        {accion === 'upt' && (
          <Btn className="p-button-sm" icon="pi pi-pencil" onClick={toggle} type="button" />
        )}

        <Modal
          show={show}
          onHide={toggle}
          size="xl"
          aria-labelledby="contained-modal-title-vcenter"
          centered

        >
          <Modal.Header  >
            <Modal.Title id="contained-modal-title-vcenter">{campo}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="container-fluid">
              <div className="row">
                <Controller
                  control={methods.control}
                  name="uniqueKeyV4"
                  defaultValue={uuid.v4()}
                  render={({ field: { value: valor } }) => <span className="col-12 ">{valor}</span>}
                />
                <InputsDinamicos inputs={fields} />
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={toggle} variant="danger" type="button">
              Cerrar
            </Button>
            <Button onClick={methods.handleSubmit(onSubmit, onSubmitError)} type="submit">
              Guardar
            </Button>
          </Modal.Footer>
        </Modal>
      </FormProvider>
    </>
  );
};
